import { pageTitleForAppTitle } from "common/page-titles";

export function setPageTitleForAppTitle(appTitle: string | undefined): void {
    const pageTitle = pageTitleForAppTitle(appTitle);
    if (document.title === pageTitle) return;

    const titles = document.getElementsByTagName("title");
    for (let i = 0; i < titles.length; i++) {
        titles[i].innerText = pageTitle;
    }
}
